import {
    useEffect,
    useMemo,
    useState,
} from 'react'

import useGetPositionTypeMapping from 'app/Apps/OrderManagement/Orders/CustomerTransport/Invoices/Positions/PositionForm/hooks/useGetPositionTypeMapping'
import FormWithControls from 'app/shared-components/FormWithControls'
import useEnumValues from 'app/hooks/useEnumValues'
import {
    PositionType,
} from 'app/enums/label.enums'
import {
    DetailPanelComponentProps,
} from 'app/shared-components/SkyNetDataGridExpandable'

import {
    LongTermLeaseInvoicePositionType,
} from 'app/requests/LongTermLeaseInvoice/LongTermLeaseInvoice.types'
import {
    RequestConfig,
} from 'app/types/request.types'

import getFields from './longTermLeaseInvoicePositionForm.fields'

const LongTermLeaseInvoicePositionForm = ({
    data,
    onSuccess,
    onCancel,
    requestParams,
    exists = false,
}: Readonly<DetailPanelComponentProps & {
    data?: LongTermLeaseInvoicePositionType,
    requestParams?: RequestConfig,
    exists?: boolean,
}>) => {
    const getAllowedValues = useEnumValues()

    const [
        value,
        setValue,
    ] = useState<LongTermLeaseInvoicePositionType>(data || {} as LongTermLeaseInvoicePositionType)

    const [
        selectedPositionType,
        setPositionType,
    ] = useState<PositionType>(data?.positionType)

    const {
        positionTypeMapping,
    } = useGetPositionTypeMapping()

    const fields = useMemo(() => {
        const allowedCodesObject = positionTypeMapping[value.positionType] || {}

        return getFields({
            positionCodeAllowedValues: getAllowedValues(allowedCodesObject),
            getAllowedValues,
        })
    }, [
        value.positionType,
        getAllowedValues,
        positionTypeMapping,
    ])

    useEffect(() => {
        if (value.positionType !== selectedPositionType) {
            setValue({
                ...value,
                positionCode: null,
            })
            setPositionType(value.positionType)
        }
    }, [
        value,
        selectedPositionType,
    ])

    return (
        <FormWithControls
            name="LongTermLeaseInvoicePositionForm"
            value={value}
            fields={fields}
            setExternalValue={setValue}
            onSuccess={onSuccess}
            onCancel={onCancel}
            requestParams={requestParams}
            exists={exists}
            cancelEnabled
        />
    )
}

export default LongTermLeaseInvoicePositionForm
